<template>
  <div class="help-card-container">
    <div class="help-card-message">
      <h3 class="card-title">{{ cardTitle }}</h3>
      <p>{{ cardMessage }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpCardComponent',
  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    cardMessage: {
      type: String,
      required: true,
    },
  },
}
</script>